import {  NeverObservable  } from './NeverObservable';

export const never = NeverObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/never.ts